




import Vue from 'vue'
import { GENERIC_STATUSES } from '@/utils/constants'

export default Vue.extend({
  props: {
    status: {
      type: String,
      required: true,
    },
    diameter: {
      type: Number,
      default: 18,
    },
  },
  computed: {
    eventIndicatorCircleClass() {
      return ['Circle-Indicator', 'Indicator-' + this.status]
    },
    cssVars() {
      return {
        '--diameter': this.diameter + 'px',
      }
    },
  },
})
